__turbopack_context__.v({
  "border-tab": "waterAccountDetails-module-scss-module__W7JhNW__border-tab",
  "border-title": "waterAccountDetails-module-scss-module__W7JhNW__border-title",
  "brief": "waterAccountDetails-module-scss-module__W7JhNW__brief",
  "container": "waterAccountDetails-module-scss-module__W7JhNW__container",
  "detail": "waterAccountDetails-module-scss-module__W7JhNW__detail",
  "detail-container": "waterAccountDetails-module-scss-module__W7JhNW__detail-container",
  "detail-header": "waterAccountDetails-module-scss-module__W7JhNW__detail-header",
  "detail-list": "waterAccountDetails-module-scss-module__W7JhNW__detail-list",
  "detail-list-item": "waterAccountDetails-module-scss-module__W7JhNW__detail-list-item",
  "detail-no-gap": "waterAccountDetails-module-scss-module__W7JhNW__detail-no-gap",
  "detail-vertical": "waterAccountDetails-module-scss-module__W7JhNW__detail-vertical",
  "edit": "waterAccountDetails-module-scss-module__W7JhNW__edit",
  "edit-icon": "waterAccountDetails-module-scss-module__W7JhNW__edit-icon",
  "edit-text": "waterAccountDetails-module-scss-module__W7JhNW__edit-text",
  "fade-in-uboa5b1": "waterAccountDetails-module-scss-module__W7JhNW__fade-in-uboa5b1",
  "name": "waterAccountDetails-module-scss-module__W7JhNW__name",
  "name-icon": "waterAccountDetails-module-scss-module__W7JhNW__name-icon",
  "name-text": "waterAccountDetails-module-scss-module__W7JhNW__name-text",
  "name-text-placeholder": "waterAccountDetails-module-scss-module__W7JhNW__name-text-placeholder",
  "skeleton-details": "waterAccountDetails-module-scss-module__W7JhNW__skeleton-details",
  "skeleton-sublist": "waterAccountDetails-module-scss-module__W7JhNW__skeleton-sublist",
  "sublist": "waterAccountDetails-module-scss-module__W7JhNW__sublist",
  "sublist-container": "waterAccountDetails-module-scss-module__W7JhNW__sublist-container",
  "subtitle": "waterAccountDetails-module-scss-module__W7JhNW__subtitle",
  "tabs": "waterAccountDetails-module-scss-module__W7JhNW__tabs",
  "tabs-large": "waterAccountDetails-module-scss-module__W7JhNW__tabs-large",
  "title": "waterAccountDetails-module-scss-module__W7JhNW__title",
  "title-icon": "waterAccountDetails-module-scss-module__W7JhNW__title-icon",
});
